import React from "react";
import { FormattedMessage } from "react-intl";

interface AlertDialogProps {
  message: string;
  styles?: string;
  itemId: string;
  alertId: string;
  alertAction: (itemId: string) => void;
  alertCancel: (alertId: string) => void;
}

export const AlertDialog: React.FC<AlertDialogProps> = ({
  message,
  styles,
  alertId,
  itemId,
  alertAction,
  alertCancel,
}) => {
  const style = styles !== undefined ? styles : "text-center";

  return (
    <div className={style}>
      <div className='flex flex-col'>
        <div className='p-4'>
          <span>{message}</span>
        </div>
        <div className='flex justify-around'>
          <div className='pb-6'>
            <button
              className='bg-brand-white hover:bg-blue-200 text-brand-blue m-4 rounded w-20 h-10'
              onClick={() => alertAction(itemId)}
            >
              <FormattedMessage id='AlertDialog.confirm_button' />
            </button>
          </div>
          <div className='pb-6'>
            <button
              className='bg-brand-white hover:bg-blue-200 text-brand-blue m-4 rounded w-20 h-10'
              onClick={() => alertCancel(alertId)}
            >
              <FormattedMessage id='AlertDialog.cancel_button' />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertDialog;
